var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from "react";
import PageHeader from "../../components/PageHeader";
import StatusCard from "../../components/StatusCard";
import UserListSingle from "../../components/UserListSingle";
import FilterModal from "../../components/modals/FilterModal";
import icons from "../../utils/Icons";
import { useDispatch, useSelector } from "react-redux";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AddUnionModal from "../../components/modals/AddUnionModal";
import useAddUnion from "../../hooks/useAddUnion";
import { updateLocalStorageAttribute, updateUserState } from "../../store/slices/userSlice";
import Spinner from "../../components/Spinner";
import AddNameToListModal from "../../components/modals/AddNameToListModal";
import CustomSpeedDial from "../../components/CustomSpeedDial";
import useFetchUserList from "../../hooks/useFetchUserList";
import useRemoveNameFromList from "../../hooks/useRemoveNameFromList";
import useFetchStatuses from "../../hooks/useFetchStatuses";
import useUpdateStatus from "../../hooks/useUpdateStatus";
import UpdateCardModal from "../../components/modals/UpdateCardModal";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import VesselFinder from "./VesselFinder";
import { toZonedTime } from "date-fns-tz";
import useChaseListNavigate from "../../hooks/useChaseListNavigate";
var convertToNewYorkTime = function (date) {
    var timeZone = "America/New_York";
    var zonedDate = toZonedTime(date, timeZone);
    return zonedDate;
};
var Home = function () {
    var listRef = useRef(null);
    var _a = useState(true), statusPanelShow = _a[0], setStatusPanelShow = _a[1];
    var _b = useState(false), showFilterModal = _b[0], setShowFilterModal = _b[1];
    var userList = useSelector(function (state) { return state.userList.list; });
    var _c = useSelector(function (state) { return state.userList; }), recordsFiltered = _c.recordsFiltered, recordsTotal = _c.recordsTotal;
    var statuses = useSelector(function (state) { return state.statuses.statuses; });
    var status_count_array = useSelector(function (state) { return state.statuses.status_count_array; });
    var lockEnabled = useSelector(function (state) { return state.statuses.lockEnabled; });
    var start_time = useSelector(function (state) { return state.statuses.start_time; });
    var end_time = useSelector(function (state) { return state.statuses.end_time; });
    var currentTime = convertToNewYorkTime(new Date());
    var format = "hh:mm A";
    var start = moment(start_time, format).toDate();
    var end = moment(end_time, format).toDate();
    var chaseListNavigate = useChaseListNavigate();
    var isCurrentTimeBetween = function () {
        console.log("start", start);
        console.log("end", end);
        // console.log("converted_current_time", converted_current_time);
        console.log("currentTime", currentTime);
        if (moment(end).isBefore(moment(start))) {
            // Handle cases where the time range spans midnight
            return (moment(currentTime).isBetween(start, moment("11:59 PM", format)) ||
                moment(currentTime).isBetween(moment("12:00 AM", format), end));
        }
        return moment(currentTime).isBetween(start, end);
    };
    var isWithinTimeRange = isCurrentTimeBetween();
    var timeToReset = 0;
    if (isWithinTimeRange) {
        timeToReset = moment(end).diff(moment(currentTime), "seconds");
        console.log("timeToReset", timeToReset);
    }
    var loadingStatuses = useSelector(function (state) { return state.statuses.loading; });
    var loadingUserList = useSelector(function (state) { return state.userList.loading; });
    var Accept = status_count_array.Accept, Active = status_count_array.Active, Decline = status_count_array.Decline, noAnswer = status_count_array["No answer"];
    var userId = useSelector(function (state) { return state.user.userId; });
    var isLoggedIn = useSelector(function (state) { return state.user.isLoggedIn; });
    var unionNo = useSelector(function (state) { return state.user.unionNo; });
    var dispatch = useDispatch();
    var _d = useState(false), showAddUnionModal = _d[0], setShowAddUnionModal = _d[1];
    var _e = useState(true), showUnionBanner = _e[0], setShowUnionBanner = _e[1];
    var _f = useAddUnion(), addUnion = _f.addUnion, savingUnion = _f.loading;
    var _g = useState(true), userExists = _g[0], setUserExists = _g[1];
    var removeName = useRemoveNameFromList().removeName;
    var updateStatus = useUpdateStatus().updateStatus;
    var _h = useState(), existingUser = _h[0], setExistingUser = _h[1];
    var isDraftUpdated = useSelector(function (state) { return state.user.isDraftUpdated; });
    var _j = useState(false), showNameListModal = _j[0], setShowNameListModal = _j[1];
    var _k = useState(false), showCardModal = _k[0], setShowCardModal = _k[1];
    var fetchUserListData = useFetchUserList().fetchUserListData;
    var _l = useFetchStatuses(), fetchDataStatusesData = _l.fetchDataStatusesData, isFetchingStatuses = _l.isFetching;
    var _m = useState(false), listRefresh = _m[0], setListRefresh = _m[1];
    var _o = useState(null), lastRefreshTime = _o[0], setLastRefreshTime = _o[1];
    useEffect(function () {
        fetchUserListData();
        fetchDataStatusesData();
        setLastRefreshTime(Date.now());
    }, [listRefresh]);
    useEffect(function () {
        var timeout;
        if (isWithinTimeRange && timeToReset > 0) {
            timeout = setTimeout(function () {
                toast.success("Records have been reset");
                window.location.href = "/";
            }, timeToReset * 1000);
        }
        return function () { return clearTimeout(timeout); };
    }, [isWithinTimeRange, timeToReset]);
    useEffect(function () {
        var interval = setInterval(function () {
            var currentTime = Date.now();
            if (!lastRefreshTime ||
                currentTime - lastRefreshTime >= 10 * 60 * 1000) {
                console.log("Refreshing data...");
                setListRefresh(function (prevRefresh) { return !prevRefresh; });
                setLastRefreshTime(currentTime);
            }
        }, 10 * 60 * 1000); // Check every 10 minutes
        return function () { return clearInterval(interval); };
    }, []);
    useEffect(function () {
        var doesUserExist = false;
        if (userId === 0) {
            setUserExists(false);
            return;
        }
        userList.map(function (user) {
            if (user.user_id === userId) {
                doesUserExist = true;
                setExistingUser(user);
            }
        });
        if (doesUserExist) {
            setUserExists(true);
        }
        else {
            setUserExists(false);
        }
    }, [userList, isLoggedIn, userId]);
    var showNameAddNameModalHandle = function (value) {
        isDraftUpdated === 0
            ? setShowCardModal(value)
            : setShowNameListModal(value);
    };
    var AddNameSuccess = function () {
        toast.success("Name added successfully");
        console.log("Name added successfully");
        setShowNameListModal(false);
        setListRefresh(!listRefresh);
    };
    var removeNameFromList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isDeleted;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!((existingUser === null || existingUser === void 0 ? void 0 : existingUser.id) !== undefined)) return [3 /*break*/, 2];
                    return [4 /*yield*/, removeName(existingUser.id)];
                case 1:
                    isDeleted = _a.sent();
                    if (isDeleted)
                        setListRefresh(!listRefresh);
                    setExistingUser(undefined);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var updateStatusAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!((existingUser === null || existingUser === void 0 ? void 0 : existingUser.id) !== undefined)) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateStatus()];
                case 1:
                    _a.sent();
                    setListRefresh(!listRefresh);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleScroll = useCallback(function () {
        if (listRef.current) {
            var scrollHeight = listRef.current.scrollHeight;
            var scrollTop = listRef.current.scrollTop;
            var clientHeight = listRef.current.clientHeight;
            var isAtBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
            // console.log("isAtBottom", isAtBottom);
            // console.log("scrollTop", scrollTop);
            // console.log("clientHeight", clientHeight);
            // console.log("scrollHeight", scrollHeight);
            if (scrollTop > 300) {
                setStatusPanelShow(false);
            }
            var isTop = Math.ceil(scrollTop) === 0;
            if (scrollTop <= 300) {
                setStatusPanelShow(true);
            }
        }
    }, []);
    var s0 = 0;
    var s1_4 = 0;
    var s5_10 = 0;
    var s10 = 0;
    var userMappedList = userList
        ? userList.map(function (item) {
            var seniority = item.seniority;
            var seniority_show = "";
            if (seniority < 1) {
                switch (seniority) {
                    case -3:
                        seniority_show = "SS";
                        break;
                    case -2:
                        seniority_show = "CAS";
                        break;
                    default:
                        seniority_show = "JRY";
                        break;
                }
                s0++;
            }
            else {
                if (seniority >= 1 && seniority <= 5) {
                    seniority_show = "".concat(seniority, " \u2022 U");
                    s1_4++;
                }
                if (seniority >= 6 && seniority <= 10) {
                    seniority_show = "".concat(seniority, " \u2022 C");
                    s5_10++;
                }
                if (seniority > 10) {
                    s10++;
                }
                if (seniority >= 11 && seniority <= 15)
                    seniority_show = "".concat(seniority, " \u2022 B");
                if (seniority >= 16 && seniority <= 20)
                    seniority_show = "".concat(seniority, " \u2022 A");
                if (seniority >= 21 && seniority <= 25)
                    seniority_show = "".concat(seniority, " \u2022 AA");
                if (seniority >= 26)
                    seniority_show = "".concat(seniority, " \u2022 AAA");
            }
            // const seniority_show = item.seniority + " • " + item.language;
            return {
                name: item.name,
                date: item.date,
                experience: seniority_show,
                status: statuses[item.deleted],
                deleted: item.deleted,
                positions: item.position,
                image: item.imgUrl,
                union_member: item.union_member,
                id: item.id,
                updated_at: item.updated_at,
                is_draft_updated: item.is_draft_updated,
            };
        })
        : [];
    useEffect(function () {
        var element = listRef.current; // Store reference to element
        if (element) {
            element.addEventListener("scroll", handleScroll);
        }
        return function () {
            if (element) {
                element.removeEventListener("scroll", handleScroll);
            }
        };
    }, [handleScroll, userMappedList]); // Correct dependency
    var showFilterHandle = function () {
        setShowFilterModal(true);
    };
    var closeFilterModal = function () {
        setShowFilterModal(false);
    };
    var applyFilter = function () {
        console.log("applying filter...");
    };
    return (_jsxs("div", { children: [_jsx(ToastContainer, { position: "top-right" }), _jsx(PageHeader, { pageTitle: "Home page" }), isLoggedIn && !unionNo && showUnionBanner && (_jsxs("div", { className: "flex items-center gap-2 bg-[#EBF2FF] border-l-4 border-[#5898FD] px-3 py-2 mx-[18px] mt-2 rounded-[8px] shadow-sm", children: [_jsx(InfoOutlinedIcon, { style: { fontSize: 17, color: '#5898FD' } }), _jsxs("span", { className: "text-[13px] font-medium text-[#333] flex-1 cursor-pointer", onClick: function () { return setShowAddUnionModal(true); }, children: ["Are you a union member? ", _jsx("span", { className: "text-[#5898FD]", children: "Add \u2192" })] }), _jsx("button", { onClick: function () { return setShowUnionBanner(false); }, className: "text-[#999] text-[16px] leading-none hover:text-[#333] bg-transparent border-none cursor-pointer", "aria-label": "Dismiss", children: "\u00D7" })] })), isWithinTimeRange && lockEnabled ? (_jsxs(_Fragment, { children: [_jsx("div", { className: "flex flex-row justify-evenly items-center", children: _jsxs("div", { className: "text-[14px] font-semibold text-center mt-4", children: ["List will open at ", moment(end).format("hh:mm A"), "."] }) }), _jsx(VesselFinder, {})] })) : (_jsxs(_Fragment, { children: [_jsx("div", { className: "flex-1 overflow-y-scroll custom-content-height lg:h-[100vh]", children: _jsxs("div", { className: "py-4 ".concat(!statusPanelShow ? 'pt-1' : 'pt-2', " px-[18px] bg-[#FAFAFA]"), children: [loadingStatuses && (_jsx("div", { className: "flex justify-center items-center h-[300px]", children: _jsx(Spinner, { size: 160 }) })), statusPanelShow && !loadingStatuses && (_jsx("div", { className: "lg:flex lg:items-center lg:gap-3 lg:my-10", children: _jsxs("div", { className: "flex gap-3 items-start w-full lg:w-[50%] mx-auto", children: [_jsx(StatusCard, { status: "Active", count: Active.toString(), bgColor: "bg-emerald-100", textColor: "text-green-600" }), _jsx(StatusCard, { status: "Accept", count: Accept.toString(), bgColor: "bg-blue-100", textColor: "text-blue-600" }), _jsx(StatusCard, { status: "Decline", count: Decline.toString(), bgColor: "bg-pink-100", textColor: "text-red-500" }), _jsx(StatusCard, { status: "No Answer", count: noAnswer.toString(), bgColor: "bg-gray-200", textColor: "text-neutral-400" })] }) })), _jsxs("div", { className: "flex justify-between items-center mt-2 w-full font-medium", children: [_jsxs("div", { className: "self-stretch my-auto text-[16px] tracking-normal text-black", children: ["Total:", recordsTotal] }), _jsxs("div", { onClick: function () { return showFilterHandle(); }, className: "flex gap-1 items-center self-stretch my-auto text-base tracking-normal text-right text-blue-400 whitespace-nowrap", children: [_jsx("div", { className: "self-stretch my-auto", children: "Filter" }), _jsx("img", { loading: "lazy", src: icons.filter, alt: "Filter icon", className: "object-contain shrink-0 self-stretch my-auto w-6 aspect-square" })] })] }), _jsxs("div", { className: "flex justify-between items-center mt-2 w-full font-medium gap-1", children: [_jsxs("span", { className: "status_count_wrapper", children: [_jsx("span", { className: "status_count_label", children: "0CAS" }), " ", _jsx("span", { className: "status_count", children: s0 })] }), _jsxs("span", { className: "status_count_wrapper", children: [_jsx("span", { className: "status_count_label", children: "U1-5" }), " ", _jsx("span", { className: "status_count", children: s1_4 })] }), _jsxs("span", { className: "status_count_wrapper", children: [_jsx("span", { className: "status_count_label", children: "C6-10" }), " ", _jsx("span", { className: "status_count", children: s5_10 })] }), _jsxs("span", { className: "status_count_wrapper", children: [_jsx("span", { className: "status_count_label", children: "11+" }), " ", _jsx("span", { className: "status_count", children: s10 })] })] }), !loadingUserList && (_jsx(_Fragment, { children: _jsx("div", { className: "flex flex-col mt-2 w-full", children: _jsx("div", { className: "lg:flex lg:flex-row lg:flex-wrap lg:gap-[12px] list-content-height overflow-y-auto p-[5px]", ref: listRef, children: userMappedList.map(function (item, index) { return (_jsx(UserListSingle, __assign({}, item), index)); }) }) }) })), loadingUserList && (_jsx("div", { className: "flex justify-center items-center h-[300px]", children: _jsx(Spinner, { size: 160 }) }))] }) }), showFilterModal && (_jsx(FilterModal, { applyFilterHandle: function () { return applyFilter(); }, closeModal: function () { return closeFilterModal(); } })), !showNameListModal && isLoggedIn && !userExists && (_jsx("button", { onClick: function () { return showNameAddNameModalHandle(true); }, className: "fixed bottom-28 right-6 rounded-full shadow-md bg-[#4bb981] w-[52px] h-[52px] flex items-center justify-center", children: _jsx("img", { src: icons.plus, alt: "Add Button" }) })), showNameListModal && (_jsx(AddNameToListModal, { addNameHandle: AddNameSuccess, closeModal: function () { return setShowNameListModal(false); }, existingUser: existingUser })), showCardModal && isDraftUpdated === 0 && (_jsx(UpdateCardModal, { closeModal: function () { return setShowCardModal(false); }, addNameHandle: function () { return setShowNameListModal(true); }, skipeHandle: function () {
                            setShowCardModal(false);
                            setShowNameListModal(true);
                        } })), isLoggedIn && userExists && existingUser && (_jsx(CustomSpeedDial, { onEditClick: function () { return setShowNameListModal(true); }, onDeleteClick: function () {
                            if (window.confirm("Are you sure you want to delete?")) {
                                removeNameFromList();
                            }
                        }, onUpdateStausClick: function () {
                            if (window.confirm("Are you sure you want to update?")) {
                                updateStatusAction();
                            }
                        }, deleted: existingUser.deleted }))] })), showAddUnionModal && (_jsx(AddUnionModal, { closeModal: function () { return setShowAddUnionModal(false); }, loading: savingUnion, onSubmit: function (extractedUnionNo, cardImage) { return __awaiter(void 0, void 0, void 0, function () {
                    var saved;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, addUnion(extractedUnionNo, cardImage)];
                            case 1:
                                saved = _a.sent();
                                if (saved) {
                                    dispatch(updateUserState({ key: 'unionNo', value: saved }));
                                    updateLocalStorageAttribute('union_no', saved);
                                    toast.success('Union number added');
                                    setShowAddUnionModal(false);
                                }
                                else {
                                    toast.error('Could not save your union number. Please try again.');
                                }
                                return [2 /*return*/];
                        }
                    });
                }); } }))] }));
};
export default Home;
